module.exports = "<a class=\"drop-menu-option-link\" *ngFor=\"let item of projects\" (click)=\"navigate($event, item)\">{{item.name}}</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/side-menu/projects-menu-drop-down/projects-menu-drop-down.component.html
// module id = 1837
// module chunks = 0